import { ProductCategory } from "@utils/constants";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";

export const OverlayConfig = (config: any) => {
  const safeConfig = config || {};

  return Object.keys(safeConfig).reduce((acc, screen) => {
    const screenData = safeConfig[screen] || {};
    const transformedSteps = (screenData.steps || []).map((step: any) => ({
      target: step?.key,
      content: step?.text,
    }));

    (acc as Record<string, any>)[screen] = {
      ...screenData,
      steps: transformedSteps,
    };

    return acc;
  }, {});
};

export const getFilteredSteps = (
  data: any,
  currentScreen: string,
  activeProduct: ProductCategory,
  selectedViewType: SearchResultsAndFavoritesEnum
) => {
  const updatedData = { ...data };

  if (updatedData.SearchResult?.steps) {
    if (
      currentScreen === "SearchResult" &&
      [ProductCategory.JEWELRY, ProductCategory.LABGROWN_JEWELRY].includes(
        activeProduct
      )
    ) {
      updatedData.SearchResult.steps = updatedData.SearchResult.steps.filter(
        (step: any) => step.target !== SearchResultsAndFavoritesEnum.CHANGE_VIEW
      );
    }
    if (selectedViewType === SearchResultsAndFavoritesEnum.GRID) {
      updatedData.SearchResult.steps = updatedData.SearchResult.steps.filter(
        (step: any) =>
          step.target !==
          SearchResultsAndFavoritesEnum.CUSTOM_COLUMN_SEARCH_RESULT
      );
    } else if (selectedViewType === SearchResultsAndFavoritesEnum.LIST) {
      updatedData.SearchResult.steps = updatedData.SearchResult.steps.filter(
        (step: any) =>
          step.target !== SearchResultsAndFavoritesEnum.SORTING_SEARCH_RESULT
      );
    }
    return updatedData;
  }

  return data;
};
